export default __webpack_public_path__ + "static/Polygon_blockchain_logo_light-76be02ba06ca4bd6a44408b85d9af594.png";